import React, { useState, useEffect } from "react";
import { online, url } from "../../utilis/contant";
import "./drawer.css";
import api from "../../utilis/api";
import { useSelector } from "react-redux";

const TeacherDrawer = ({ teacher }) => {
  const [selectedDate, setSelectedDate] = useState("");
  const [selectedSlot, setSelectedSlot] = useState(null);
  const [bookedSlots, setBookedSlots] = useState([]);
  const [show, setShow] = useState(false);
  const { user } = useSelector((state) => state.auth);
  const [coment, setComment] = useState();
  // ================= Helper Functions =================
  const getDayName = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString("en-US", { weekday: "long" });
  };
  const formatToYYYYMMDD = (dateStr) => dateStr.split("T")[0];

  const isSlotBooked = (slot) =>
    bookedSlots.some(
      (s) =>
        s.start === slot.start &&
        s.end === slot.end &&
        formatToYYYYMMDD(s.date) === selectedDate,
    );

  const formatSlot = ({ start, end }) => {
    const formatHour = (h) => {
      const ampm = h >= 12 ? "PM" : "AM";
      const hour = h % 12 === 0 ? 12 : h % 12;
      return `${hour}:00 ${ampm}`;
    };
    return `${formatHour(start)} - ${formatHour(end)}`;
  };

  // ================= Fetch Booked Slots =================
  const fetchBookedSlots = async () => {
    if (!selectedDate) return;
    try {
      const res = await api.get("/booking", {
        params: { teacherId: teacher._id, date: selectedDate },
      });
      if (res.data.success) {
        const slots = res.data.data.map((b) => {
          const [start, end] = b.time
            .split("-")
            .map((t) => parseInt(t.split(":")[0]));
          return { start, end, date: b.date };
        });
        setBookedSlots(slots);
      }
    } catch (err) {
      console.error("Failed to fetch booked slots:", err);
    }
  };

  useEffect(() => {
    fetchBookedSlots();
    setSelectedSlot(null);
  }, [selectedDate]);

  // ================= Generate Teacher Slots =================
  const generateSlots = () => {
    if (!selectedDate) return [];

    const day = teacher.availability.find(
      (d) => d.day === getDayName(selectedDate) && d.isActive,
    );

    if (!day || !day.slots.length) return [];

    const slotRanges = [];
    day.slots.forEach((range) => {
      const [startHour, endHour] = range.split("-").map((t) => parseInt(t));
      for (let h = startHour; h < endHour; h++) {
        slotRanges.push({ start: h, end: h + 1 });
      }
    });

    return slotRanges;
  };

  const slots = generateSlots();

  // ================= Handle Slot Click =================
  const handleSlotClick = (slot) => {
    if (!isSlotBooked(slot)) setSelectedSlot(slot);
  };

  // ================= Book Appointment =================
  const handleBookAppointment = async () => {
    if (!selectedSlot || !selectedDate) {
      alert("Please select a date and a slot first");
      return;
    }

    try {
      const payload = {
        studentId: user._id,
        teacherId: teacher._id,
        date: selectedDate,
        time: `${selectedSlot.start}:00-${selectedSlot.end}:00`,
        duration: 1,
      };

      const response = await api.post("/booking", payload);

      if (response.data.success) {
        alert("Appointment booked successfully!");
        setBookedSlots([
          ...bookedSlots,
          { ...selectedSlot, date: selectedDate },
        ]);
        setSelectedSlot(null);
      }
    } catch (err) {
      console.error(err);
      alert(err.response?.data?.message || "Failed to book appointment");
    }
  };
  // Get Comments
  const fetchComments = async () => {
    try {
      const teacherId = teacher._id;
      console.log(teacherId);
      const res = await api.get(`/review/teacher/${teacherId}`);
      if (res.data) {
        console.log(res.data);
        setComment(res.data);
      }
    } catch (err) {
      console.error("Failed to fetch booked slots:", err);
    }
  };

  useEffect(() => {
    if (teacher?._id) {
      fetchComments();
    }
  }, [teacher]);
  const getInitials = (name) => {
    if (!name) return "";
    const names = name.split(" ");
    return names
      .map((n) => n[0]?.toUpperCase())
      .join("")
      .slice(0, 2); // Max 2 letters
  };
  return (
    <div className="teacher-drawer">
      {/* Header / Bio Section */}
      <div className="drawer-header">
        <h2 className="teacher-name">{teacher.name || "Teacher"}</h2>
        <p className="teacher-bio">{teacher.bio || "No bio available."}</p>
      </div>

      {/* Intro Video */}
      {teacher.introVideo && (
        <div className="video-container">
          <video controls className="teacher-video">
            <source src={`${url}/${teacher.introVideo}`} type="video/mp4" />
          </video>
        </div>
      )}

      {/* Skills */}
      <div className="skills-section">
        <h3>Skills</h3>
        <div className="skills-tags">
          {teacher.skills?.length > 0 ? (
            teacher.skills.map((skill, idx) => (
              <span key={idx} className="skill-tag">
                {skill}
              </span>
            ))
          ) : (
            <p>No skills listed</p>
          )}
        </div>
      </div>
      <div className="skills-section">
        <button
          style={{
            background: "none",
            border: "none",
            color: "#1976d2",
            fontSize: "14px",
            fontWeight: "600",
            cursor: "pointer",
            textDecoration: "underline",
            padding: "0",
          }}
          onMouseOver={(e) => (e.currentTarget.style.color = "#0d47a1")}
          onMouseOut={(e) => (e.currentTarget.style.color = "#1976d2")}
          onClick={() => setShow(!show)}
        >
          View Reviews
        </button>
        {show && (
          <div style={{ padding: "1rem 0rem" }}>
            {coment?.map((com, index) => (
              <div
                style={{
                  display: "flex",
                  justifyContent: "start",
                  alignItems: "start",
                  gap: "0.5rem",
                  flexDirection: "column",
                  padding: "1rem",
                  marginTop: "1rem",
                  borderRadius: "20px",
                  boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "1rem",
                  }}
                >
                  <>
                    {com.studentId.image ? (
                      <img
                        src={com.studentId.image}
                        alt={com.studentId.name}
                        className="teacher-avatar"
                      />
                    ) : (
                      <div className="teacher-avatar avatar-fallback">
                        {getInitials(com.studentId.name)}
                      </div>
                    )}
                  </>
                  <h1
                    style={{
                      color: "#444",
                      fontSize: "20px",
                    }}
                  >
                    {com.studentId.name}
                  </h1>
                </div>
                <p
                  style={{
                    color: "#555",
                    fontSize: "16px",
                    fontWeight: "450",
                  }}
                >
                  {com.comment}
                </p>
              </div>
            ))}
          </div>
        )}
        {/* <div className="skills-tags">
          {teacher.skills?.length > 0 ? (
            teacher.skills.map((skill, idx) => (
              <span key={idx} className="skill-tag">
                {skill}
              </span>
            ))
          ) : (
            <p>No skills listed</p>
          )}
        </div> */}
      </div>
      {/* Booking Section */}
      {/* <div className="booking-section">
        <h3>Book a One-on-One Session</h3>

        <div className="date-picker">
          <label htmlFor="date">Select Date</label>
          <input
            type="date"
            id="date"
            value={selectedDate}
            onChange={(e) => setSelectedDate(e.target.value)}
            className="date-input"
            min={new Date().toISOString().split("T")[0]} // Prevent past dates
          />
        </div>

        {selectedDate && (
          <>
            <div className="slots-section">
              <h4>Available Slots</h4>
              <div className="slots-grid">
                {slots.length > 0 ? (
                  slots.map((slot, idx) => {
                    const isBooked = isSlotBooked(slot);
                    const isSelected =
                      selectedSlot &&
                      selectedSlot.start === slot.start &&
                      selectedSlot.end === slot.end;

                    return (
                      <button
                        key={idx}
                        className={`slot-btn ${isBooked ? "booked" : ""} ${isSelected ? "selected" : ""}`}
                        onClick={() => handleSlotClick(slot)}
                        disabled={isBooked}
                      >
                        {formatSlot(slot)}
                      </button>
                    );
                  })
                ) : (
                  <p className="no-slots">No available slots for this date</p>
                )}
              </div>
            </div>

            <button
              className="book-appointment-btn"
              onClick={handleBookAppointment}
              disabled={!selectedSlot}
            >
              {selectedSlot
                ? `Book ${formatSlot(selectedSlot)}`
                : "Select a Time Slot"}
            </button>
          </>
        )}
      </div> */}
    </div>
  );
};

export default TeacherDrawer;
